import type { Components } from 'react-markdown';

/**
 * Como o markdown do Brain é desenhado na visão renderizada: código com rolagem,
 * links em nova aba e tabelas com borda. Compartilhado entre a Soul e a Mind.
 */
export const markdownComponents: Components = {
  pre: ({ className, children, ...props }) => (
    <pre
      className={`overflow-auto max-h-64 rounded-md bg-muted p-3 text-xs font-mono whitespace-pre-wrap break-all text-foreground ${className || ''}`}
      {...props}
    >
      {children}
    </pre>
  ),
  code: ({ className, children, ...props }: React.ComponentPropsWithoutRef<'code'> & { inline?: boolean }) => {
    const { inline } = props as { inline?: boolean };
    if (inline) {
      return (
        <code className={`font-mono bg-muted text-foreground px-1 py-0.5 rounded text-xs break-words whitespace-pre-wrap ${className || ''}`} {...props}>
          {children}
        </code>
      );
    }
    return (
      <code className={`font-mono block whitespace-pre-wrap break-all text-foreground ${className || ''}`} {...props}>
        {children}
      </code>
    );
  },
  a: ({ href, children, ...props }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  ),
  table: ({ children, ...props }) => (
    <div className="overflow-x-auto my-4">
      <table className="w-full border-collapse text-sm" {...props}>{children}</table>
    </div>
  ),
  thead: ({ children, ...props }) => (
    <thead className="bg-muted/50" {...props}>{children}</thead>
  ),
  th: ({ children, ...props }) => (
    <th className="border border-border px-3 py-2 text-left font-semibold text-foreground" {...props}>{children}</th>
  ),
  td: ({ children, ...props }) => (
    <td className="border border-border px-3 py-2 text-foreground" {...props}>{children}</td>
  ),
  tr: ({ children, ...props }) => (
    <tr className="even:bg-muted/20" {...props}>{children}</tr>
  ),
};
